import { Node } from '@tiptap/pm/model';
import { Plugin } from '@tiptap/pm/state';
import { columnResizingPluginKey, TableMap } from '@tiptap/pm/tables';
import { EditorView } from '@tiptap/pm/view';

interface FixColumnWidthsArgs {
  view: EditorView;
  table: Node;
  tableStart: number;
}

const fixColumnWidths = ({ view, table, tableStart }: FixColumnWidthsArgs) => {
  const { map: cellPositions, width: columnCount } = TableMap.get(table);

  const columnWidths = cellPositions.slice(0, columnCount).map((position) => {
    const cellElement = view.nodeDOM(tableStart + position);

    return cellElement instanceof HTMLElement ? cellElement.offsetWidth : 0;
  });

  const { tr } = view.state;

  new Set(cellPositions).forEach((position) => {
    const columnIndex = cellPositions.indexOf(position) % columnCount;

    tr.setNodeAttribute(tableStart + position, 'colwidth', [columnWidths[columnIndex]]);
  });

  view.dispatch(tr.setMeta('addToHistory', false));
};

const mouseDownHandler = (view: EditorView) => {
  const { state } = view;

  const resizeState = columnResizingPluginKey.getState(state);

  if (!resizeState || resizeState.activeHandle === -1) {
    return false;
  }

  const $cell = state.doc.resolve(resizeState.activeHandle);

  const table = $cell.node(-1);

  if (table.firstChild?.children.every(({ attrs }) => attrs.colwidth)) {
    return false;
  }

  fixColumnWidths({ view, table, tableStart: $cell.start(-1) });

  return false;
};

export const fixColumnWidthsOnResize = () =>
  new Plugin({ props: { handleDOMEvents: { mousedown: mouseDownHandler } } });
